import {Route} from '@/apiTypes/event';
import {formatDistance, formatElevation} from '@/utils/displayFormatUtils';
import {Mountain, TrendingUp} from 'lucide-react';
import {FC} from 'react';
import {Typography} from '../../ui/typography';

interface RouteHeaderProps {
  /**
   * The route to render
   */
  route: Route;
  /**
   * Whether to show the route name. On events with a single route,
   * we don't display any route name.
   */
  showName?: boolean;
}

export const RouteHeader: FC<RouteHeaderProps> = ({route, showName = true}) => {
  const {distance_meters, elevation_gain_meters, name} = route;
  return (
    <div className="flex flex-col gap-1">
      {showName && <Typography level="B2">{name}</Typography>}
      {route.description && (
        <Typography level="B3" className="text-neutral-500">
          {route.description}
        </Typography>
      )}
      <div className="flex gap-4 items-center">
        {distance_meters && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <TrendingUp className="w-4 h-4 text-gray-400" />
            <Typography level="B3" className="text-neutral-500">
              {formatDistance(distance_meters)}
            </Typography>
          </div>
        )}
        {elevation_gain_meters && (
          <div className="flex items-center gap-2">
            <Mountain className="w-4 h-4 text-gray-400" />
            <Typography level="B3" className="text-neutral-500">
              {formatElevation(elevation_gain_meters)}
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
};
